// Dados gerais on Firebase: the account is the signed-in user's uid, which
// is also her accountId claim (setupAccount sets one to the other,
// poweryourflow-ops/docs/decisions.md, SPEC-14). The uid is read from the
// persisted session, so this answers offline too, where a token refresh
// to read the claim would fail.
//
// SPEC-54: an account the team created carries `createdByTeam: true` in
// its ID token, set by adminCreateAccount with accountId, before her first
// sign-in; so every token she holds has it and no refresh is forced. A
// token that cannot be read (expired, offline) rejects, and the screen
// keeps the default minimum age.

import { dataLayer } from "../data";
import type { Onboarding } from "./onboarding";

export const firebaseOnboarding: Onboarding = {
  async accountId() {
    // Loaded on demand: firebase.ts throws while the config is blank
    // (HANDOFF.md, step F5), and that must cost this screen only.
    const { auth } = await import("../lib/firebase");
    await auth.authStateReady();
    return auth.currentUser?.uid ?? null;
  },
  async createdByTeam() {
    const { auth } = await import("../lib/firebase");
    await auth.authStateReady();
    const user = auth.currentUser;
    if (!user) return false;
    return (await user.getIdTokenResult()).claims["createdByTeam"] === true;
  },
  data: dataLayer,
};
